import React from 'react';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { Toaster } from 'react-hot-toast';

/**
 * Envuelve la app con Chakra UI y react-hot-toast.
 * Usar en index.js: <AppProviders><App /></AppProviders>
 */
export function AppProviders({ children }) {
  return (
    <ChakraProvider value={defaultSystem}>
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { maxWidth: 400 },
        }}
      />
    </ChakraProvider>
  );
}
